import LanguageSelectorContainer from './LanguageSelectorContainer';

export default LanguageSelectorContainer;